import React from "react";
import "./App.css";
import ComponentsWrapper from './ComponentsWrapper';



function App(props) {
  return (
    <div className="App">
    <ComponentsWrapper />
    </div>
  );
}

export default App;
